import ArticleLayout from "@/components/feature/ArticleLayout";

export default function BeginnerArticle() {
  return <ArticleLayout slug="pandabuy-sheet-beginner-guide" />;
}